module.exports = __webpack_public_path__ + "static/media/file.7dc61a18.png";